<template>
  <div class="wraper">
    <el-row class="top">
      <span>基础报表</span>
      <el-tooltip placement="right">
        <div slot="content">
          渠道报表：以渠道为维度，对渠道内的设备统一查看管理
          <br/>累计客流：渠道内所有大数据冷柜客流量总和(开关门次数-补货次数)
          <br/>平均日客流：渠道内平均每台设备每天客流量
          <br/>平均纯净度：渠道内所有大数据冷柜纯净度平均值
          <br/>累计销售额：渠道内所有大数据冷柜销售额量总和(排除补货、退货状态后，各商品销售数量*对应单价后金额总和)
          <br/>平均销售额：渠道内平均每台设备每天额销售额
          <br/>累计销量：渠道内所有大数据冷柜销量总和(排除补货、退货状态后，各商品销售数量总和）
          <br/>平均销量：渠道内平均每台设备每天的销售额
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-date-picker
        size="mini"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="clearDate"
      >
        <!--  :picker-options="pickerOptions" -->
      </el-date-picker>
      <el-button size="mini" type="primary" @click="search">查询</el-button>
      <div class="export_btn">
        <exporter
          :setting="setting"
          :postParams="postParams"
          :url="getListUrl"
          :date="date"
          :exportName="exportName"
          :reportType="reportType"
        ></exporter>
      </div>
    </el-row>
    <!-- 筛选条件 -->
    <deviceSearchBox
      :postParams="postParams"
      @getSearchSelect="searchTable"
    ></deviceSearchBox>
    <!-- 柱状图 -->
    <div id="selectdiv">
      <select @change="changeReport">
        <option>城市销售报表</option>
        <option>大区销售报表</option>
        <option>渠道销售报表</option>
      </select>
    </div>
    <el-row style="margin-bottom:60px;">
      <div
        style="display: flex;
    justify-content: space-between;"
      >
        <div class="spanClass">
          <span
            v-for="(item, index) in reportList"
            @click="indexClick(index, item)"
            :key="index"
            :class="{ active: index == isActive }"
          >{{ item }}</span
          >
        </div>
        <div class="days">
          <span @click="dayClick()">天</span>
          <span class="active" @click="weekClick()">周</span>
          <span @click="mounthClick()">月</span>
        </div>
      </div>
      <div :style="{ height: '350px' }" id="main"></div>
    </el-row>
    <!-- table 表 -->
    <div class="shouQi" ref="content" @click="showTable()">
      收起明细数据 ^
    </div>
    <el-row v-show="isShow">
      <report-basic
        :setting="setting"
        :list="list"
        :date="date"
        @changeSort="handleSun"
      ></report-basic>
      <!-- 分页 -->
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import ReportBasic from '../../components/reportsBasic'
import exporter from '../../components/exporter'
import deviceSearchBox from '../devices/components/deviceSearchBox'
import * as echarts from 'echarts'
import echartsDown from '../../../static/download.png'

export default {
  name: 'channel',
  components: {
    ReportBasic,
    exporter,
    deviceSearchBox
  },
  data () {
    return {
      isShow: true,
      isActive: 0,
      active: 'active',
      exportName: '基础报表',
      barlist: [], //

      sumareName: [], // 大区列表
      sumassets: [], // 设备数量台
      sumsumCustomerFlow: [], // 累计客流量
      sumsumSalesAmount: [], // 累计销售额
      sumavgPurity: [], // 纯净度
      sumavgSalesAmount: [], // 平均销售额
      sumavgCustomerFlow: [], // 平均客流
      sumavgSalesNum: [], // 平均销量
      sumsumSalesNum: [], // 累计

      reportList: [
        '设备数量/台',
        '累计客流/台',
        '平均客流/台',
        '平均专放率/%',
        '累计销量/台',
        '平均销量/台',
        '累计销售额/台',
        '平均销售额/台'
      ],
      reportType: '3', // 1为大区销售报表 2为渠道销售报表 3为城市渠道报表
      postParams: {
        areaCompanyId: '',
        provinceBranchCompanyId: '',
        productModelType: '',
        agencyType: '',
        channelType: '',
        secondChannelType: '',
        thirdChannelType: '',
        dealerCompanyId: '',
        cityCode: '',
        marketType: '',
        provinceCode: '',
        putPolicy: '',
        storeId: '',
        keyWord: '',
        putInYear: '',
        areaCompanyName: '', // 大区名称
        channelName: '' // 渠道类型
      },
      getListUrl: 'data/getDataReport_ChannelList',
      date: this.getDefaultDay(),
      clearDate: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24
        },
        shortcuts: [
          {
            text: '昨天',
            onClick (picker) {
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, start])
            }
          },
          {
            text: '最近七天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      currentPage: 1,
      setting: {
        isShowSelect: false,
        isShowIndex: false,
        tHeader: [
          {
            dataItem: 'province',
            dataName: '省份',
            width: '120px'
          },
          {
            dataItem: 'city',
            dataName: '城市',
            width: '120px'
          },
          {
            dataItem: 'putAssetsNum',
            dataName: '设备数量',
            width: '120px'
          },
          {
            dataItem: 'sumCustomerFlow',
            dataName: '累计客流（人/台）',
            width: '170px'
          },
          {
            dataItem: 'avgCustomerFlow',
            dataName: '平均客流（人/台/天）',
            width: '190px'
          },
          {
            dataItem: 'avgPurity',
            dataName: '平均专放率 （%）',
            width: '170px'
          },
          {
            dataItem: 'sumSalesNum',
            dataName: '累计销量（个/台）',
            width: '170px'
          },
          {
            dataItem: 'avgSalesNum',
            dataName: '平均销量（个/台/天）',
            width: '190px'
          },
          {
            dataItem: 'sumSalesAmount',
            dataName: '累计销售额（元/台）',
            width: '200px'
          },
          {
            dataItem: 'avgSalesAmount',
            dataName: '平均销售额（元/台/天）',
            width: '200px'
          }
        ],
        isShowPlay: true,
        isShowDelBtn: false,
        isShowEditBtn: false,
        isShowInfoBtn: true,
        isShowAssetsBtn: true,
        btnsWidth: '200px',
        infoUrl: 'channelDetail'
      },
      list: [],
      total: 0,
      pageSize: 10
    }
  },
  mounted () {
    this.getList()
    // this.drawCharts();
  },
  methods: {
    drawCharts (xData, yData) {
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)

      var option
      if (this.reportType == '1' || this.reportType == '2') {
        myChart.getDom().style.height = 550 + 'px'
        option = {
          grid: {
            left: '3%',
            x2: '1%'
          },
          // toolbox: {
          //   x: "20px",
          //   y: "10px",

          //   feature: {
          //     saveAsImage: {
          //       show: true,
          //       icon: `image://${echartsDown}`,
          //       backgroundColor: "transparent",
          //       title: "保存图片",
          //       type: "png",
          //       pixelRatio: 1
          //     }
          //   }
          // },
          xAxis: {
            type: 'category',
            data: xData,
            axisLine: {
              lineStyle: {
                color: '#fff',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#FFFFFF',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          series: [
            {
              data: yData,
              type: 'bar',
              barMaxWidth: '20%',
              label: {
                show: true,
                position: 'top',
                color: '#fff'
              },
              itemStyle: {
                normal: {
                  color: 'rgb(253, 213, 151)'
                }
              }
            }
          ]
        }
      } else if (this.reportType == '3') {
        var autoHeight = this.sumareName.length * 50 + 200

        myChart.getDom().style.height = autoHeight + 'px'

        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            }
          },

          grid: {
            left: '10%',
            x2: '1%',
            right: '5%'
          },
          xAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#fff',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          yAxis: {
            type: 'category',
            data: xData,
            axisLine: {
              lineStyle: {
                color: '#FFFFFF',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          },
          series: [
            {
              type: 'bar',
              data: yData,
              label: {
                show: true,
                position: 'right'
              },
              barMaxWidth: '20%',
              itemStyle: {
                normal: {
                  color: 'rgb(253, 213, 151)'
                }
              }
            }
          ]
        }
      }
      myChart.resize()
      option && myChart.setOption(option)
    },
    showTable () {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.$refs.content.innerHTML = '收起明细数据 ^'
      } else {
        this.$refs.content.innerHTML = '展开明细数据 v'
      }
    },
    getDefaultDay () {
      let date = new Date()
      let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8)
      let startyear = startdate.getFullYear()
      let startmonth = startdate.getMonth() + 1
      if (startmonth < 10) {
        startmonth = '0' + startmonth
      }
      let startday = startdate.getDate()
      if (startday < 10) {
        startday = '0' + startday
      }
      startdate = startyear + '-' + startmonth + '-' + startday
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24)
      let endyear = enddate.getFullYear()
      let endmonth = enddate.getMonth() + 1
      if (endmonth < 10) {
        endmonth = '0' + endmonth
      }
      let endday = enddate.getDate()
      if (endday < 10) {
        endday = '0' + endday
      }
      enddate = endyear + '-' + endmonth + '-' + endday
      return [startdate, enddate]
    },
    getList (val) {
      let url = this.getListUrl
      let paramsObj = this.postParams
      console.log(paramsObj, '------')
      let params = {
        startDay: this.date[0],
        endDay: this.date[1],
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        reportType: this.reportType
      }
      if (val != undefined) {
        params.order = val.order
        params.prop = val.prop
      }
      for (let k in paramsObj) {
        if (paramsObj[k] != '') params[k] = paramsObj[k]
      }
      let _this = this
      this.$ajax
        .post(url, params)
        .then(this.getListSucc)
        .catch(function (res) {
          _this.$message.error('哎呀~网络异常了呢')
        })
    },
    getListSucc (res) {
      (this.sumareName = []),
      (this.sumassets = []),
      (this.sumsumCustomerFlow = []),
      (this.sumsumSalesAmount = []),
      (this.sumavgPurity = []),
      (this.sumavgSalesAmount = []),
      (this.sumavgCustomerFlow = []),
      (this.sumavgSalesNum = []),
      (this.sumsumSalesNum = []),
      console.log(res)
      if (res.data && res.data.code === 200) {
        const data = res.data.data
        this.list = data.tableList.list
        this.total = data.tableList.total
        this.barlist = data.barList
        var self = this
        this.barlist.forEach((item, index) => {
          if (self.reportType == '1') {
            if (!item.sumareaName) {
              item.sumareaName = '未知'
            }
            self.sumareName.push(item.sumareaName) // 大区名称
            self.sumassets.push(item.sumassets)
            self.sumsumCustomerFlow.push(item.sumsumCustomerFlow)
            self.sumsumSalesAmount.push(item.sumsumSalesAmount)
            self.sumavgPurity.push(item.sumavgPurity)
            self.sumavgSalesAmount.push(item.sumavgSalesAmount)
            self.sumavgCustomerFlow.push(item.sumavgCustomerFlow)
            self.sumavgSalesNum.push(item.sumavgSalesNum)
            self.sumsumSalesNum.push(item.sumsumSalesNum)
          } else {
            if (!item.sumareaName) {
              item.sumareaName = '未知'
            }
            switch (item.sumareaName) {
              case 1:
                item.sumareaName = '家批'
                break
              case 2:
                item.sumareaName = '校园'
                break
              case 3:
                item.sumareaName = '商区'
                break
              case 4:
                item.sumareaName = '景区'
                break
              case 5:
                item.sumareaName = '交运'
                break
              case 6:
                item.sumareaName = '街边'
                break
              case 7:
                item.sumareaName = '社区'
                break
              case 8:
                item.sumareaName = '现代'
                break
              case 9:
                item.sumareaName = '特通'
                break
              case 11:
                item.sumareaName = 'KA'
                break
              case 12:
                item.sumareaName = 'CVS'
                break
              case 13:
                item.sumareaName = 'CVS渠道'
                break
              default:
                break
            }
            self.sumareName.push(item.sumareaName) // 大区名称
            self.sumassets.push(item.sumassets)
            self.sumsumCustomerFlow.push(item.sumsumCustomerFlow)
            self.sumsumSalesAmount.push(item.sumsumSalesAmount)
            self.sumavgPurity.push(item.sumavgPurity)
            self.sumavgSalesAmount.push(item.sumavgSalesAmount)
            self.sumavgCustomerFlow.push(item.sumavgCustomerFlow)
            self.sumavgSalesNum.push(item.sumavgSalesNum)
            self.sumsumSalesNum.push(item.sumsumSalesNum)
          }
        })

        this.indexClick(this.isActive)
      } else {
        let errMsg = '未知错误'
        if (res.data.msg) {
          errMsg = res.data.msg
        }
        this.$message.error(errMsg)
      }
    },
    search () {
      this.getList()
    },
    handleSizeChange (val) {
      // console.log('每页 '+val+' 条');
      this.pageSize = val
      this.currentPage = 1
      this.getList()
      // console.log(this.pageSize);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    handleSun (val) {
      this.getList(val)
    },
    searchTable () {
      // console.log(this.postParams,"00")
      this.getList()
    },
    // 变换颜色
    indexClick: function (index, item) {
      this.isActive = index
      // console.log(index, "------------");
      switch (index) {
        case 0:
          this.drawCharts(this.sumareName, this.sumassets)
          break
        case 1:
          this.drawCharts(this.sumareName, this.sumsumCustomerFlow)
          break
        case 2:
          this.drawCharts(this.sumareName, this.sumavgCustomerFlow)
          break
        case 3:
          this.drawCharts(this.sumareName, this.sumavgPurity)
          break
        case 4:
          this.drawCharts(this.sumareName, this.sumsumSalesNum)
          break
        case 5:
          this.drawCharts(this.sumareName, this.sumavgSalesNum)
          break
        case 6:
          this.drawCharts(this.sumareName, this.sumsumSalesAmount)
          break
        case 7:
          this.drawCharts(this.sumareName, this.sumavgSalesAmount)
          break
        default:
          break
      }
    },
    // 其他兄弟节点移除active 类
    siblings (elm) {
      var p = elm.parentNode.children
      for (var i = 0, pl = p.length; i < pl; i++) {
        if (p[i] !== elm) {
          p[i].classList.remove('active')
        }
      }
    },
    // 转换时间
    timeFormat (time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear()
      let month =
        time.getMonth() + 1 > 10
          ? time.getMonth() + 1
          : '0' + (time.getMonth() + 1)
      let day = time.getDate() > 10 ? time.getDate() : '0' + time.getDate()
      return year + '-' + month + '-' + day
    },

    // 选择天
    dayClick () {
      var obj = document.getElementsByClassName('days')[0]
      var nowNode = obj.firstElementChild
      this.siblings(nowNode)
      nowNode.classList.add('active')
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24)

      this.date = [this.timeFormat(start), this.timeFormat(start)]
      this.search()
    },
    // 选择周
    weekClick () {
      var nowNodes = document
        .getElementsByClassName('days')[0]
        .getElementsByTagName('span')
      this.siblings(nowNodes[1])
      nowNodes[1].classList.add('active')

      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
      this.date = [this.timeFormat(start), this.timeFormat(end)]
      this.search()
    },
    // 选择月
    mounthClick () {
      var nowNodes = document
        .getElementsByClassName('days')[0]
        .getElementsByTagName('span')
      this.siblings(nowNodes[2])
      nowNodes[2].classList.add('active')
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.date = [this.timeFormat(start), this.timeFormat(end)]
      this.search()
    },
    // 更改报表
    changeReport (e) {
      console.log(e.target.value)
      if (e.target.value == '大区销售报表') {
        this.reportType = '1'
        this.setting.tHeader.splice(0, 2)
        this.setting.tHeader.unshift(
          {
            dataItem: 'areaCompanyName',
            dataName: '大区',
            width: '120px'
          },
          {
            dataItem: 'provinceCompanynName',
            dataName: '省区',
            width: '120px'
          }
        )
        this.getList()
      } else if (e.target.value == '渠道销售报表') {
        this.reportType = '2'
        this.setting.tHeader.splice(0, 2)
        this.setting.tHeader.unshift(
          {
            dataItem: 'channelTypeName',
            dataName: '渠道',
            width: '120px'
          },
          {
            dataItem: 'secondChannelTypeName',
            dataName: '二级渠道',
            width: '120px'
          }
        )
        this.getList()
      } else {
        this.reportType = '3'
        this.setting.tHeader.splice(0, 2)
        this.setting.tHeader.unshift(
          {
            dataItem: 'province',
            dataName: '省份',
            width: '120px'
          },
          {
            dataItem: 'city',
            dataName: '城市',
            width: '120px'
          }
        )
        this.getList()
      }
    }
  }
}
</script>
<style scoped>
.active {
  background: rgb(251, 170, 123);
  color: #000;
}

#selectdiv {
  margin-bottom: 10px;
}

#selectdiv select {
  height: 30px;
  background: transparent;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
}

#selectdiv select option {
  background: transparent;
  color: black;
}

.top {
  height: 50px;
}

.spanClass {
  width: 60%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  font-size: 14px;
}

.spanClass span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px;
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;
  flex-shrink: 1;
}

.days span {
  display: inline-block;
  border: 1px solid rgb(251, 170, 123);
  padding: 3px 15px;
  float: left;
  margin-top: 5px;

  cursor: pointer;
}

.pages {
  padding-top: 10px;
  text-align: center;
}

.shouQi {
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/reports/channel.vue